/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-max-props-per-line */
import {Card} from 'primereact/card';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import DataTableLazy from '../../components/DataTableLazy';
import StringUtils from '../../utils/StringUtils';
import InternalUserService from '../../services/MobileUserService';
import AuthService from '../../services/AuthService';
import {Avatar, SelectButton} from 'primereact';
import {FaTrophy} from 'react-icons/fa';
import CriteriaCalendarComponent from '../../components/criteria/CriteriaCalendarComponent';
import ImageSimpleComponent from '../../components/inputs/ImageSimpleComponent';
import { t } from 'i18next';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';

export const DashboardRankComponent = ({
    transportTypes,
    rankingTitle,
    myPlaceTitle,
    rankingPageable,
    fatchRanking,
    getRankingCleanSearchCriteria,
    rows,
    rowsPerPageOptions,
    useDateRange,
    participateInGlobalChallenge = false,
}) => {
    useEffect(() => {}, []);
    const [statistic, setStatistic] = useState({name:  t('dashboard.travaled_distance'), type: 'TRAVELED_DISTANCE'});
    const [criteria, setCriteria] = useState(getRankingCleanSearchCriteria());
    const [transportType, setTransportType] = useState(transportTypes.length !== 0 ? transportTypes[0] : undefined);
    const mobileUserService = new InternalUserService();
    const authService = new AuthService();
    const [currentDate, setCurrentDate] = useState(new Date());
    const [dateFrom, setDateFrom] = useState(undefined);
    const [dateTo, setDateTo] = useState(undefined);

    useEffect(() => {
        if (useDateRange) {
            setDateFrom(criteria?.dateFrom);
            setDateTo(criteria?.dateTo);
        } else if (criteria?.date) {
            setCurrentDate(criteria.date);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const rankTemplate = (rowData) => {
        if (rowData.rank === 1) {
            return <FaTrophy className='text-warning' color='' style={{fontSize: '28px'}}></FaTrophy>;
        }
        if (rowData.rank === 2) {
            return (
                <b>
                    <div style={{fontSize: '22px', marginLeft: '7px'}}>{rowData.rank}</div>
                </b>
            );
        }
        if (rowData.rank === 3) {
            return (
                <b>
                    <div style={{fontSize: '18px', marginLeft: '8px'}}>{rowData.rank}</div>
                </b>
            );
        }
        return <div style={{fontSize: '16px', marginLeft: '9px'}}>{rowData.rank}</div>;
    };

    const avatarTemplate = (rowData) => {
        const id = rowData?.user?.id;
        const avatarPath = mobileUserService.getPath() + `/${id}/avatar/user`;
        const img = StringUtils.isBlank(id) ? (
            ''
        ) : (
            <ImageSimpleComponent srcUrl={`${avatarPath}?token=${authService.getToken()}`} borderRadius={50} height={40} width={40} />
        );
        return img;
    };

    const cleanPaginationCriteria = (criteria) => {
        criteria.firstResult = 0;
        criteria.maxResults = rows;
    };
    const getStatistics = () => {
        if (transportType?.transportId === '-2') {
            return [{name: 'CO₂', type: 'SAVED_CO2'}];
        }
        if (transportType?.transportId === '-1') {
            return [
                {name: t('dashboard.points'), type: 'EARNED_COINS'},
                {name: t('dashboard.steps'), type: 'STEPS'},
            ];
        }
        return [
            {name: t('dashboard.travaled_distance'), type: 'TRAVELED_DISTANCE'},
            {name: t('dashboard.points'), type: 'EARNED_COINS'},
            {name: t('dashboard.wort-travel'), type: 'TRAVEL_TO_WORK_COUNT'},
            {name: t('dashboard.average-speed'), type: 'AVERAGE_SPEED'},
            {name: t('dashboard.calories-burned'), type: 'BURNED_CALORIES'},
        ];
    };

    const getTransportOptions = () => {
        if (!participateInGlobalChallenge) {
            return transportTypes;
        }
        return [...transportTypes, { name: 'Do pracy bez spalin', transportId: '-2' }];
    };
    return (
        <div>
            <Card className='dashboard-card-rank mt-1' title={<div className='title'>{rankingTitle}</div>}>
                <div className='row'>
                    <div className='col-lg-8'>
                        <SelectButton
                            optionLabel='name'
                            value={transportType}
                            options={getTransportOptions()}
                            onChange={(e) => {
                                if (!e.value?.transportId) {
                                    return;
                                }
                                let defaultStat;
                                if (e.value.transportId === '-2') {
                                    defaultStat = {name: 'CO₂', type: 'SAVED_CO2'};
                                } else if (e.value.transportId === '-1') {
                                    defaultStat = {name: t('dashboard.points'), type: 'EARNED_COINS'};
                                } else {
                                    defaultStat = {name: t('dashboard.travaled_distance'), type: 'TRAVELED_DISTANCE'};
                                }
                                criteria.transportId = e.value.transportId;
                                criteria.type = defaultStat.type;
                                cleanPaginationCriteria(criteria);
                                setTransportType(e.value);
                                setStatistic(defaultStat);
                                fatchRanking(criteria);
                                setCriteria(criteria);
                            }}
                        />
                    </div>
                    <div className='col-lg-4'>
                        {useDateRange ? (
                            <CriteriaCalendarRangeComponent
                                idFrom='rank-date-from'
                                idTo='rank-date-to'
                                nameFrom='dateFrom'
                                nameTo='dateTo'
                                from={dateFrom}
                                to={dateTo}
                                label={'Zakres'}
                                onChange={(type, names, e) => {
                                    const value = e?.value;
                                    const name = e?.target?.name;
                                    if (name === 'dateFrom') {
                                        setDateFrom(value);
                                        criteria.dateFrom = value;
                                    } else if (name === 'dateTo') {
                                        setDateTo(value);
                                        criteria.dateTo = value;
                                    }
                                    delete criteria.date;
                                    fatchRanking(criteria);
                                }}
                                sharedLabel={true}
                                inputsClassName='col-md-6'
                                colClass='col-lg-12'
                                showButtonBar={true}
                            />
                        ) : (
                            <CriteriaCalendarComponent
                                id='dateSc'
                                name='date'
                                showIcon
                                colClass='col-lg-12'
                                viewMode='EDIT'
                                value={currentDate}
                                onChange={(a, b, e, d, f, g, h) => {
                                    if (e.value === null) {
                                        e.value = '';
                                        e.target.value = '';
                                    }
                                    setCurrentDate(e.target.value);
                                    criteria.date = e.target.value;
                                    delete criteria.dateFrom;
                                    delete criteria.dateTo;
                                    fatchRanking(criteria);
                                }}
                                view='month'
                                placeholder='mm-yy'
                                dateFormat='mm-yy'
                            />
                        )}
                    </div>
                </div>

                <SelectButton
                    optionLabel='name'
                    value={statistic}
                    options={getStatistics()}
                    onChange={(e) => {
                        if (!e.value?.type) {
                            return;
                        }
                        criteria.type = e.value.type;
                        criteria.transportId = transportType.transportId;
                        cleanPaginationCriteria(criteria);
                        setStatistic(e.value);
                        fatchRanking(criteria);
                        setCriteria(criteria);
                    }}
                />

                <DataTableLazy
                    id='rank-table'
                    dataPageable={rankingPageable}
                    rendered={true}
                    filterDisplay={'menu'}
                    fetchReturnResolve={false}
                    rows={rows}
                    loadLazyData={(criteria) => {
                        fatchRanking(criteria);
                    }}
                    paginator={true}
                    onSelect={() => {}}
                    rowsPerPageOptions={rowsPerPageOptions || []}
                    initialCriteria={criteria}
                    columns={[
                        {field: '', header: t('dashboard.place'), body: rankTemplate},
                        {field: 'user.id', header:  t('dashboard.avatar'), body: avatarTemplate}, 
                        {field: 'user.name', header:  t('dashboard.user')},
                        {field: 'value', header: t('dashboard.value'), bodyStyle: { textAlign: 'center', fontVariantNumeric: 'tabular-nums', fontFeatureSettings: '"tnum"' }, style: { width: '80px' }},
                    ]}
                />
            </Card>
        </div>
    );
};

DashboardRankComponent.defaultProps = {};

DashboardRankComponent.propTypes = {
    rankingTitle: PropTypes.string,
    transportTypes: PropTypes.array,
    myPlaceTitle: PropTypes.string,
    rankingPageable: PropTypes.object,
    getRankingCleanSearchCriteria: PropTypes.func.isRequired,
    fatchRanking: PropTypes.func.isRequired,
    participateInGlobalChallenge: PropTypes.bool,
};

export default withTranslation()(DashboardRankComponent);
